module.exports = __webpack_public_path__ + "aad56fc638be9e45d67e22ca47465067.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/banner-category.png
// module id = ./assets/images/banner-category.png
// module chunks = 0